/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import './HeaderMobile.scss'
import { DangKyDangNhapMobile } from '../../../LayoutMobile/DangKyDangNhapMobile'
import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../component/MaHoaDuLieu/MaHoaDuLieu'
import { useUser } from '../../../component/UserProvider/UserProvider'
import { getApiUrl } from '../../../api/api'
import Loading from '../../../component/Loading/Loading'
function HeaderMobile () {
  const [tab, settab] = useState('Đăng nhập')
  const [isOpen, setisOpen] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const hasFetched = useRef(false)
  const data_user =
    JSON.parse(getFromlocalstorage('data_u')) ||
    JSON.parse(getFromsessionstorage('data_u'))
  const [isLoading, setIsLoading] = useState(false)
  const { user, fetchUser } = useUser()

  useEffect(() => {
    if (data_user && !hasFetched.current) {
      fetchUser(data_user._id)
      hasFetched.current = true
    }
  }, [data_user])

  const handleRutTienGame = async () => {
    try {
      setIsLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/withdraw-game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userData: data_user
        })
      })

      if (response.ok) {
        fetchUser(data_user._id)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }
  return (
    <>
      <Loading isLoading={isLoading} />
      <header className='navmobile headermobile'>
        <div className='nav_list_mobile'>
          <div className='nav_item_mobile'>
            <div className='left_slot'>
              <div className='logo_mobile'>
                <img src='/logomobile.png' alt='' />
              </div>
            </div>
          </div>
          <div className='header_title_mobile'></div>
          <div className='nav_item_mobile'>
            <div className='right_slot'>
              {dangnhap === 'true' ? (
                <div className='user-container-mobile'>
                  <div className='user_balance_mobile'>
                    <div className='user_dollar_mobile'>
                      <div className='user_dollar_sign'>THB</div>
                      <div className='user_dollar_amount'>
                        <a className='user_money_mobile'>
                          <span className='amount_user_mobile'>
                            {user?.coins === 0
                              ? '0.00'
                              : Number(
                                  (user?.coins || 0).toFixed(0)
                                ).toLocaleString('en-US') || 0}
                          </span>
                        </a>
                        <i
                          className='icon_reload_container'
                          onClick={handleRutTienGame}
                        >
                          <i className='icon_reload'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='100%'
                              height='100%'
                              viewBox='0 0 12 12'
                              fill='none'
                            >
                              <path
                                d='M11.4999 8.25L10.9999 5.75L8.49989 6.75L9.56498 7.375C9.09161 8.92 7.66656 10.05 5.9851 10.05C4.29378 10.05 2.85886 8.905 2.39535 7.34L1.26123 7.685C1.86281 9.75 3.75137 11.25 5.98017 11.25C8.17445 11.25 10.0285 9.8 10.6695 7.79L11.4999 8.25Z'
                                fill='currentColor'
                              ></path>
                              <path
                                d='M0.761341 3.75L1.26134 6.25L3.76134 5.25L2.69625 4.625C3.16962 3.08 4.59467 1.95 6.27613 1.95C7.96746 1.95 9.40237 3.095 9.86588 4.66L11 4.315C10.3984 2.25 8.50986 0.75 6.28106 0.75C4.08678 0.75 2.23274 2.2 1.59172 4.21L0.761341 3.75Z'
                                fill='currentColor'
                              ></path>
                            </svg>
                          </i>
                        </i>
                      </div>
                    </div>
                  </div>
                  <Link to='/naptienmobile' className='nav-link-recharge'>
                    <img src='/login/iconnaptien.png' alt='' />
                  </Link>
                </div>
              ) : (
                <div className='users_link'>
                  <a
                    className='btnlogin_mobile aheadermobile'
                    onClick={e => {
                      e.preventDefault()
                      setisOpen(true)
                      settab('Đăng nhập')
                    }}
                  >
                    Đăng nhập
                  </a>
                  <a
                    className='btnreg_mobile aheadermobile'
                    onClick={e => {
                      e.preventDefault()
                      setisOpen(true)
                      settab('Đăng ký')
                    }}
                  >
                    Đăng ký
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <DangKyDangNhapMobile
        tab={tab}
        isOpen={isOpen}
        onClose={() => setisOpen(false)}
        settab={settab}
      />
    </>
  )
}

export default HeaderMobile
